<template>
  <div class="cg-landing">
    <h2 class="cg-landing-title">Prenotazione completata</h2>
    <p class="cg-landing-message">La tua richiesta di prenotazione è stata inviata correttamente. Riceverai una conferma via email.</p>
  </div>
</template>

<style scoped>
.cg-landing {
  padding: 2rem 0;
  font-family: system-ui, -apple-system, sans-serif;
  text-align: center;
}

.cg-landing-title {
  font-size: 2rem;
  font-weight: 800;
  color: #111827;
  margin: 0 0 0.75rem 0;
}

@media (min-width: 640px) {
  .cg-landing-title {
    font-size: 3rem;
  }
}

.cg-landing-message {
  font-size: 1rem;
  color: #374151;
  margin: 0;
  max-width: 36rem;
  margin-left: auto;
  margin-right: auto;
}
</style>
